import React from 'react';
import MonthRangeSelectComponent from '../../components/Filters/monthRangeSelect';
import dateToString from '../../helpers/dateToString';
import stringToDate from '../../helpers/stringToDate';
import moment from 'moment';

class MonthRangeSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDate: new Date(),
            untilDate: null,
            dateRange: [],
            minDateFrom: new Date(),
            maxDateFrom: new Date(),
            minDateUntil: new Date(),
            maxDateUntil: new Date(),
        }
        this.handleFromDateChange = this.handleFromDateChange.bind(this);
        this.handleUntilDateChange = this.handleUntilDateChange.bind(this);
    }

    componentDidMount() {
        this.setInitialState();
    };

    componentDidUpdate(prevProps) {
        if (prevProps.filters !== this.props.filters) {
            this.setInitialState();
        }
    }

    notifyParentFilter(fromDate, untilDate){
        const { id, handleTimeSelect } = this.props;

        if((fromDate === undefined) || (fromDate === null) || (untilDate === undefined) || (untilDate === null)){
            return
        }

        if(handleTimeSelect !== undefined){
            var data = {
                fromDate: fromDate,
                untilDate: untilDate,
                filterId: id
            }
            handleTimeSelect(data);
        }
    }

    /**
     * Asigna valor inicial para rango de fechas.
    */
    setInitialState() {
        const { id, name, data, defines } = this.props;
        const { untilDate } = this.state;
        var parametersArray = [];
        var parameters = '';
        const dateRange = [];

        const fromDateString = data[0];
        const untilDateString = data[1];

        const minDateString = defines[0].value;
        const maxDateString = defines[1].value;

        const fromDate = stringToDate(fromDateString);
        const untilDateClone =  null; //Fecha "Hasta" en blanco

        const minDate = stringToDate(minDateString);
        var maxDate = stringToDate(maxDateString);
        maxDate = maxDate < fromDate ? fromDate : maxDate;

        dateRange.push(fromDateString, untilDateClone);
        this.setState({
            fromDate: fromDate,
            untilDate: untilDateClone,
            dateRange: dateRange,
            minDateFrom: minDate,
            maxDateFrom: maxDate,
            minDateUntil: fromDate,
            maxDateUntil: maxDate,
        });
        parametersArray.push(
            'parameter',
            '<name>',
            dateRange[0],
            '</name>',
            '</parameter>',
            '<parameter>',
            '<name>',
            dateRange[1],
            '</name>',
            '</parameter>'
        );
        parameters = parametersArray.join('');
        //const parameters = `<parameter><name>` + dateRange[0] + `</name></parameter><parameter><name>` + dateRange[1] + `</name></parameter>`
        const message = {
            id: id,
            name: name,
            parameters: parameters
        }
    }

    /**
     * Asigna fecha de inicio (desde) y actualiza filtros con fecha seleccionada.
     * @param {Date} date - Fecha asignada para inicio de rango.
    */
    handleFromDateChange(date) {
        this.setState({ fromDate: date });
        const { id, name, updateFiltersMessage } = this.props;
        var parametersArray = [];
        var parameters = '';
        const dateRange = [...this.state.dateRange];
        if (date != null){
            const dateString = dateToString(date);
            dateRange[0] = dateString;
            this.setState({ dateRange: dateRange });
            parametersArray.push(
                '<parameter>',
                '<name>',
                dateRange[0],
                '</name>',
                '</parameter>',
                '<parameter>',
                '<name>',
                dateRange[1],
                '</name>',
                '</parameter>'
            );
            parameters = parametersArray.join('');
            const message = {
                id: id,
                name: name,
                parameters: parameters
            }
            this.setState({ minDateUntil: date })
            updateFiltersMessage(message);
            this.notifyParentFilter(dateRange[0], dateRange[1]);
        }
    };

    /**
     * Asigna fecha de fin (hasta) y actualiza filtros con fecha seleccionada.
     * @param {Date} date - Fecha asignada para fin de rango.
    */
    handleUntilDateChange(date) {
        this.setState({ untilDate: date })
        var parametersArray = [];
        var parameters = '';
        if (date >= this.state.minDateUntil) {
            const { id, name, updateFiltersMessage } = this.props;
            const dateString = dateToString(date);
            const dateRange = [...this.state.dateRange];
            dateRange[1] = dateString;
            this.setState({ dateRange: dateRange });
            parametersArray.push(
                '<parameter>',
                '<name>',
                dateRange[0],
                '</name>',
                '</parameter>',
                '<parameter>',
                '<name>',
                dateRange[1],
                '</name>',
                '</parameter>'
            );
            parameters = parametersArray.join('');
            //const parameters = `<parameter><name>` + dateRange[0] + `</name></parameter><parameter><name>` + dateRange[1] + `</name></parameter>`;
            const message = {
                id: id,
                name: name,
                parameters: parameters
            }
            updateFiltersMessage(message);
            this.notifyParentFilter(dateRange[0], dateRange[1]);
            this.setState({ maxDateFrom: date })
        }

    }

    render() {
        const { fromDate, untilDate, minDateFrom, maxDateFrom, minDateUntil, maxDateUntil } = this.state;
        const { required } = this.props;
        return (
            <MonthRangeSelectComponent
                fromDate={fromDate}
                untilDate={untilDate}
                handleUntilDateChange={this.handleUntilDateChange}
                handleFromDateChange={this.handleFromDateChange}
                required={required}
                minDateFrom={minDateFrom}
                maxDateFrom={maxDateFrom}
                minDateUntil={minDateUntil}
                maxDateUntil={maxDateUntil}
            />
        )
    }
}

export default MonthRangeSelect;